export default async function copyToClipboard(val: string) {
	try {
		await navigator.clipboard.writeText(val);
	}
	catch(err) {
		// use document .execCommand() as  a fallback if navigator.clipboard.writeText(val) fails
		const selBox = document.createElement('textarea');
		selBox.setAttribute('style', 'position: fixed; opacity: 0; pointer-events: none');
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
	}
	finally {
		console.log('Copied to clipboard!');
	}
}
